module.exports = __webpack_public_path__ + "img/carousal6.10b0787e.jpg";